import { Box, BoxProps, Flex, List, ListItem, Text } from '@chakra-ui/react';
import React from 'react';

import { ListUtils } from '../../framework/utils/ListUtils';
import { PageMainId } from '../constants/Page';
import { useSizeContext } from '../containers/SizeProvider';

export type StyledListItem = {
  earliest_date: string;
  items: Array<{ content: React.ReactNode; kind?: PageMainId }>;
};

export type StyledListProps = BoxProps & {
  header?: React.ReactNode;
  items: React.ReactNode[];
  onClickItem?: Runnable;
  isMessage?: boolean;
  hasBorder?: boolean;
};

/**
 * 枠線つきのリスト
 * @param header - ヘッダ
 * @param items - リストアイテム
 * @returns
 */
const StyledList: React.FunctionComponent<StyledListProps> = ({
  header,
  items,
  isMessage,
  onClickItem,
  hasBorder,
  ...props
}) => {
  const sizes = useSizeContext();

  return (
    <Flex
      justify="center"
      width="100%"
      border={hasBorder ? '2px' : undefined}
      borderRadius={hasBorder ? 'md' : undefined}
      borderColor={hasBorder ? 'gray.300' : undefined}
      borderBottom={hasBorder ? 'none' : undefined}
      hidden={ListUtils.isEmpty(items)}
      {...props}
    >
      <Box w="full">
        <Text
          fontWeight="bold"
          fontSize={sizes.fontSize.listHeader}
          hidden={!header}
        >
          {header}
        </Text>
        <List>
          {isMessage
            ? items
            : items.map((item, idx) => (
                <ListItem
                  key={idx}
                  fontSize={sizes.fontSize.listMessage}
                  onClick={onClickItem}
                  backgroundColor="white"
                  borderBottom={hasBorder ? '2px' : undefined}
                  borderColor="gray.300"
                  cursor={onClickItem ? 'pointer' : undefined}
                  borderRadius={onClickItem ? '2xl' : undefined}
                  boxShadow={
                    onClickItem ? '4px 3px 5px 0px rgba(0,0,0,0.35)' : undefined
                  }
                  paddingX={onClickItem ? 4 : 1}
                  paddingY={onClickItem ? 2 : 1}
                >
                  {item}
                </ListItem>
              ))}
        </List>
      </Box>
    </Flex>
  );
};

export default StyledList;
